import theme from '../theme/theme';


export const drawerWidth = 256;

export default {
  root: {
    display: 'flex',
    minHeight: '100vh',
    width: '100%'
  },
  drawer: {
    [theme.breakpoints.up('lg')]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  app: {
    flex: 1,
   // display: 'flex',
    //flexDirection: 'column',
  },
  main: {
   // flex: 1,
 //   padding: theme.spacing(6, 4),
  [theme.breakpoints.up('sm')]: {
     padding: theme.spacing(6, 4),
      //flexShrink: 0,
    },
    margin: "auto",
   // background: '#fff',
  },
  foot: {
    padding: theme.spacing(2),
   // background: '#eaeff1',
  },
};